



















import Vue from 'vue'
import { mapGetters } from 'vuex'
import Form from '@/types/Form.interface'
import IListTile from '@/types/components/IListTile.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListTileColumn from '@/types/components/IListTileColumn.interface'
import Button from '@/types/components/Button.interface'
export default Vue.extend({
    data() {
        return {
            formsListPlaceholder: {
                content: 'No Forms Found',
                img: 'noMessages'
            },
            //  Our icon that gets displayed for our forms in the IList
            formIcon: {
                type: IListIconType.icon,
                content: 'mdi-form-select',
                color: 'primary'
            } as IListIcon,

            toolbar: {
                title: 'Forms',
                help: {
                    title: 'Forms',
                    body: 'Grow your text message subscriber list by sharing forms on your website, social pages, or with a QR code. Customize forms to collect the right information so you can organize your contacts into groups for Broadcast messaging.',
                    button: {
                        text: ' Learn More',
                        link: `${process.env.VUE_APP_URL_LEARN}/en/articles/5076369-contact-forms-overview`
                    }
                },
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/settings',
                        tooltip: 'Back',
                        permission: 0,
                        feature: null
                    }
                ],
                right: []
            }
        }
    },
    computed: {
        ...mapGetters({
            forms: 'formsViewForms'
        }),
        formsEnabled(): boolean {
            // return this.$store.getters.getEnabled('form')
            return true
        },
        showPaywall(): boolean {
            //  Grab our forms
            const forms = this.forms

            //  Get the total number of forms
            const total = forms.length

            //  If we have null OR if the total is 0, return true
            if (!forms || !total) return true

            //  Else, get the number of required forms (if they changed the name, they're good)
            const required = forms.filter(
                (x: Form) => x.name === 'Lead Collection Form' && x.type === 'contactform'
            )

            //  If we our required and total are the same length, return true
            if (required.length === total) return true

            //  Else, we return false
            return false
        }
    },
    methods: {
        async createNewForm(): Promise<void> {
            //  Create the payload for our formsPost
            const payload = { type: 'dynamicform' }

            // Else, create the form
            const resp = await this.$store.dispatch('formsPost', payload)

            //  If no response, do nothing
            if (!resp) return

            // If there was a response, navigate to the form profile
            this.$router.push(`/forms/${resp.id}`)
        },
        formActions(form: Form): IListAction {
            //  Create our menu buttons
            const menu: Button[] = [
                {
                    icon: 'bi-trash-fill',
                    text: 'Delete',
                    color: 'red',
                    callback: () => this.formDelete(form)
                }
            ]

            //  Create our list action
            const action: IListAction = {
                type: IListActionType.menu,
                menu: menu
            }

            //  Return our list action
            return action
        },
        formColumns(form: Form): IListTileColumn[] {
            //  Create our first column
            const one: IListTileColumn = {
                line2: form.name
            }

            //  Create our second column
            const two: IListTileColumn = {
                line2: `<span>Submissions: ${form.submissions}</span>`
            }

            //  Create our columns container
            const columns: IListTileColumn[] = [one, two]

            //  Retunr our columns
            return columns
        },
        formDelete(form: Form): void {
            //  If the form is a contact form, prompt the error message
            if (form.type === 'contactform') {
                return this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Error',
                    text: 'The anonymous leads collection form cannot be deleted.',
                    icon: 'mdi-alert',
                    color: 'red darken-2'
                })
            }

            //  Else, prompt the user to delete the form
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Form?',
                text: `Are you sure you want to delete this form?`,
                icon: 'mdi-alert',
                color: 'red darken-2',
                callback: async (result: boolean): Promise<void> => {
                    //  If the user selected 'NO', do nothing
                    if (!result) return

                    //  Else, delete the form
                    const res = await this.$store.dispatch('formsDelete', form.id)

                    //  If the request failed, do nothing
                    if (!res) return

                    //  Else, notify the user of success
                    this.$store.commit('appNotificationBarSet', {
                        message: 'Form deleted'
                    })
                }
            })
        },
        formTile(): IListTile {
            return {
                leftIcon: this.formIcon,
                actionContent: (form: Form) => this.formActions(form),
                columns: (form: Form) => this.formColumns(form),
                callback: (form: Form) => this.goToForm(form)
            }
        },
        //  Set the selected form and nav to form profile
        goToForm(form: Form): void {
            //  Navigate to the form
            this.$router.push(`/forms/${form.id}?sender=${this.$route.path}`)
        }
    }
})
